import styled from '@emotion/styled'
import {theme} from '../../accountManagement/theme'

export const Page = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  overflow-x: hidden;
`

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`

export const PageTitle = styled.h1`
  font-size: ${theme.fontSizes['3xl']};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.space[1]};
`

export const PageSubtitle = styled.p`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text.primary};
  margin: 0;
`

export const Toolbar = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 12px;
  border-bottom: 1px solid ${theme.colors.border.light};
`

export const Filters = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;

  & .search-filter input[type='text'] {
    min-width: 0;
    width: 220px;
    height: 35px;
    box-sizing: border-box;
  }

  @media (max-width: 600px) {
    width: 100%;

    & .search-filter {
      width: 100%;
    }

    & .search-filter input[type='text'] {
      flex: 1;
      width: auto;
    }
  }
`

export const SearchBox = styled.input`
  height: 36px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.md};
  font-size: ${theme.fontSizes.base};
  background: #fff;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${theme.colors.input.focusRing};
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`

export const Card = styled.div`
  background: #fff;
  border: 1px solid ${theme.colors.border.light};
  border-radius: ${theme.radii.md};
  /* visible so the filter dropdown lists aren't clipped */
`

export const Table = styled.table`
  width: calc(100% - 32px);
  margin: 12px 16px 0;
  border-collapse: collapse;

  th {
    text-align: left;
    padding: 12px 16px;
    font-size: ${theme.fontSizes.base};
    font-weight: ${theme.fontWeights.bold};
    color: #1f2a4d;
    background: #dfe7fb;
  }

  td {
    padding: 12px 16px;
    font-size: ${theme.fontSizes.base};
    color: #0f172a;
    border-top: 1px solid ${theme.colors.border.light};
    vertical-align: middle;
  }

  th:last-child,
  td:last-child {
    text-align: right;
  }

  tbody tr {
    transition: background 0.15s ease;
  }

  tbody tr:hover {
    background: #f4f6fb;
  }

  /* Phone: stacked rows, no horizontal scroll */
  @media (max-width: 768px) {
    thead {
      display: none;
    }
    tr,
    td {
      display: block;
    }
    tr {
      padding: 8px 0;
      border-top: 1px solid ${theme.colors.border.light};
    }
    td {
      border: none;
      padding: 4px 16px;
    }
    td:last-child {
      text-align: left;
    }
    td[data-label]::before {
      content: attr(data-label) ': ';
      font-weight: ${theme.fontWeights.semibold};
      color: ${theme.colors.text.muted};
    }
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }

  /* Action buttons: gray background. Details, Cancel and Follow-up are
     Maverick modal triggers, so style by selector. Buttons inside the modals
     are left alone. Schedule Follow-up and Join Now get the orange theme button. */
  & button:not(.modal *) {
    height: 32px !important;
    padding: 0 12px !important;
    font-size: ${theme.fontSizes.small} !important;
    font-weight: ${theme.fontWeights.medium} !important;
    border-radius: ${theme.radii.md} !important;
    background: #e5e7eb !important;
    color: #000000 !important;
    border: none !important;
    box-shadow: none !important;
  }

  & button:not(.modal *):hover:not(:disabled) {
    background: #d1d5db !important;
  }

  & .follow-up button:not(.modal *),
  & .join-now button:not(.modal *) {
    background: #ffdccc !important;
    box-shadow: inset 0 0 0 1px #ff5000 !important;
  }

  & .follow-up button:not(.modal *):hover:not(:disabled),
  & .join-now button:not(.modal *):hover:not(:disabled) {
    background: #ff5000 !important;
    color: #ffffff !important;
  }
`

export const Badge = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  color: ${({status}) => (status === 'cancelled' ? '#b42318' : '#067647')};
  background: ${({status}) => (status === 'cancelled' ? '#fef3f2' : '#ecfdf3')};
`

export const Empty = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: ${theme.colors.text.muted};
`

export const PagerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid ${theme.colors.border.light};
  font-size: ${theme.fontSizes.sm};
`
